var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
		'snap-to-top',
		'button',
		{
			'snap-to-top-visible': _vm.visible
		}
	],attrs:{"aria-label":"Scroll to top"},on:{"click":_vm.onClick}},[_vm._v("\n\t▲\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }